import { colorAttentionBlue60, colorFunctionalGray30, colorMiscGray90, fontSizeS, fontSizeXs, spacingM, spacingS, spacingXl, } from "@rhumbix/rmbx_design_system_design_tokens";
import React from "react";
import styled from "styled-components";
import Copy from "../Copy";
const KeyValueSelectorOption = ({ title, kvPairs, rightContent }) => (React.createElement(Container, null,
    React.createElement("div", { className: "overflowControl" },
        React.createElement(Copy, { tag: "div", color: colorMiscGray90, bold: true, className: "title" }, title),
        kvPairs.map(([key, value]) => (React.createElement("div", { className: "keyValueLine", key: key },
            React.createElement(Copy, { color: colorAttentionBlue60 }, `${key}: `),
            React.createElement(Copy, { color: colorAttentionBlue60, bold: true }, value))))),
    rightContent && React.createElement("div", { className: "rightContent" }, rightContent)));
const Container = styled.div `
    padding-top: ${spacingS};
    padding-bottom: ${spacingS};
    margin-left: ${spacingM};
    border-bottom: 1px solid ${colorFunctionalGray30};
    display: flex;
    justify-content: space-between;

    .overflowControl {
        max-width: 350px;
        padding-right: ${spacingXl};
    }

    .title {
        margin-bottom: ${spacingS};
        font-size: ${fontSizeS};
    }

    .keyValueLine {
        font-size: ${fontSizeXs};
    }

    .rightContent {
        padding-right: ${spacingM};
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
export default KeyValueSelectorOption;
